module.exports = __webpack_public_path__ + "static/screenshot1-560148cfc0b82eadc790e04955b0ecfc.png";